import { commonTranslationEN } from '@common/translations/en';

export const translationsEN = {
  ...commonTranslationEN,
  'Grid Opt': 'Grid Opt',
  'Tabs': 'Tabs',
  'Datasheets': 'Datasheets',
  'Export Datasheet Format': 'Export Datasheet Format',
  'Load Datasheet Format': 'Load Datasheet Format',
  'Add New Datasheet': 'Add New Datasheet',
  'Add a tab to the datasheet': 'Add a tab to the datasheet',
  'Tab name': 'Tab name',
  'Copy tab': 'Copy tab',
  'Rename tab': 'Rename tab',
  'Delete Tab': 'Delete Tab',
  'Are you sure you want to delete this tab?': 'Are you sure you want to delete this tab?',
  'Failed to get update tab': 'Failed to get update tab',
  'Field has been already added': 'Field has been already added',
  'Default Settings': 'Default Settings',
  'Tab Order': 'Tab Order',
  'Show Border': 'Show Border',
  'Show Field Type': 'Show Field Type',
  'Heading': 'Heading',
  'Display Heading': 'Display Heading',
  'Added Text': 'Added Text',
  'Help Text': 'Help Text',
  'Save As Datasheet Format': 'Save As Datasheet Format',
  'Failed to save datasheet format': 'Failed to save datasheet format',
  'Horizontal Grid': 'Horizontal Grid',
  'Vertical Grid': 'Vertical Grid',
  'wouldYouLikeToOverwriteFormatName': 'This name has already been used, would you like to overwrite the current format being used by this name?',
  'Overwrite': 'Overwrite',
  'Configure Table': 'Configure Table',
  'Failed to get update configure table': 'Failed to get update configure table',
  'Save Table Format': 'Save Table Format',
  "Align Left": "Align Left",
  "Align Right": "Align Right",
  "Align Top": "Align Top",
  "Align Bottom": "Align Bottom",
  "Size Horz": "Size Horz",
  "Size Vert": "Size Vert",
  'fieldExistsInTab': 'Field already exists in this tab. Please select a field and try again.',
  'Show Grid': 'Show Grid',
  'Show Page Breaks': 'Show Page Breaks',
  'Snap to Grid': 'Snap to Grid',
  'Show/Edit Tab Order': 'Show/Edit Tab Order',
  'Show Margins': 'Show Margins',
  'FHQ': 'FHQ',
  'Tablet': 'Tablet',
  'Custom': 'Custom',
  'Reset Tab Order': 'Reset Tab Order',
  'Datasheet Printing': 'Datasheet Printing',
  'Paper format': 'Paper format',
  'Paper orientation': 'Paper orientation',
  'Print Column': 'Print Column',
  'landscape': "landscape",
  'portrait': "portrait",
  'Order Test': 'Order Test',
  'Test Results': 'Test Results',
  'Generate Letter': 'Generate Letter',
  'Failed to load UPNs': 'Failed to load UPNs',
  'StTerrProvName': 'ST/Terr/Prov Name',
  'State': 'State',
  'Recently Used Datasheet Formats': 'Recently Used Datasheet Formats',
  'Set Current Format as the Default for this Folder': 'Set Current Format as the Default for this Folder'
};